export default __webpack_public_path__ + "static/FuturaBT-Book-4cd8acbbb36a4e523389e0a52729ff3b.ttf";